import { render, staticRenderFns } from "./GoogleSettings.vue?vue&type=template&id=088ad519&"
import script from "./GoogleSettings.vue?vue&type=script&lang=js&"
export * from "./GoogleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports